import { useState } from "react";
import { toast } from "sonner";
import { Send, MailOpen } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { api } from "@/lib/api";

const IMG = "/assets/pausa-liberta.jpg";

export const EmailCapture = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) {
      toast.error("Inserisci un indirizzo email valido");
      return;
    }
    setLoading(true);
    try {
      await api.post("/leads", { email, source: "checklist_10_attivita", origin_url: window.location.origin });
      toast.success("Fatto! Ti abbiamo riservato il Capitolo 1: controlla la tua inbox.");
      setEmail("");
    } catch {
      toast.error("Qualcosa è andato storto. Riprova tra poco.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <div className="grid overflow-hidden rounded-[2.5rem] bg-terracotta lg:grid-cols-[1.2fr_1fr]">
            <div className="p-10 sm:p-16">
              <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-linen/15 text-linen">
                <MailOpen className="h-5 w-5" />
              </div>
              <h2 className="mt-8 font-serif text-2xl tracking-tight text-linen sm:text-3xl lg:text-4xl">
                Non sei pronta a decidere?
                <span className="block italic">Scarica l'omaggio gratuito.</span>
              </h2>
              <p className="mt-5 max-w-md text-base leading-relaxed text-linen/70">
                Lascia la tua email e ricevi gratis in PDF <strong className="text-linen">"10 attività che puoi delegare da domani"</strong> —
                la checklist per scoprire subito quante ore puoi liberare.
              </p>
              <form onSubmit={submit} className="mt-10 flex max-w-md flex-col gap-3 sm:flex-row">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="la-tua@email.it"
                  data-testid="email-capture-input"
                  className="w-full rounded-full border border-linen/20 bg-linen/5 px-6 py-4 text-sm text-linen placeholder:text-linen/40 focus:border-rose focus:outline-none"
                />
                <button
                  type="submit"
                  disabled={loading}
                  data-testid="email-capture-submit-button"
                  className="flex shrink-0 items-center justify-center gap-2 rounded-full bg-linen px-7 py-4 text-sm font-semibold text-terracotta transition-all hover:bg-sand disabled:opacity-60"
                >
                  {loading ? "Invio…" : "Ricevi la checklist"} <Send className="h-4 w-4" />
                </button>
              </form>
              <p className="mt-4 text-xs text-linen/40">Zero spam. Solo strumenti per lavorare meglio, e vivere di più.</p>
            </div>
            <div className="relative min-h-[18rem] lg:min-h-0">
              <img src={IMG} alt="Una donna si gode il suo caffè al balcone: la sua prima ora di libertà" className="absolute inset-0 h-full w-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-r from-terracotta/60 to-transparent lg:bg-gradient-to-r" />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
